import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="bg-dark text-light py-5 mt-5">
      <Container>
        <Row>
          <Col md={4}>
            <div className="d-flex align-items-center mb-3">
              <img 
                src="/assets/pllogo.jpeg" 
                alt="Precision Analytical Lab Solutions"
                height="40"
                className="me-2"
              />
              <div>
                <h5 className="royal-blue-text mb-0">Precision Analytical</h5>
                <small className="text-muted">Lab Solutions</small>
              </div>
            </div>
            <p className="emerald-green-border pb-2 mb-3">
              "Precision That Powers Solutions"
            </p>
            <p className="small">
              Serving East Africa with high-quality laboratory equipment and analytical solutions.
            </p>
          </Col>
          <Col md={4}>
            <h5>Contact Info</h5>
            <p className="small">
              <strong>Phone:</strong> 0799228282<br/>
              <strong>Email:</strong> info@precision-lab-solutions.com<br/>
              <strong>Location:</strong> Nairobi, Kenya
            </p>
            <div className="mt-3">
              <h6>Follow Us</h6>
              <div className="d-flex gap-3">
                <a href="#" className="text-light">
                  <i className="fab fa-facebook fa-lg"></i>
                </a>
                <a href="#" className="text-light">
                  <i className="fab fa-twitter fa-lg"></i>
                </a>
                <a href="#" className="text-light">
                  <i className="fab fa-linkedin fa-lg"></i>
                </a>
              </div>
            </div>
          </Col>
          <Col md={4}>
            <h5>Quick Links</h5>
            <ul className="list-unstyled small">
              <li className="mb-2">
                <Link to="/services" className="text-light text-decoration-none">
                  <i className="fas fa-chevron-right me-2 small"></i>
                  Our Services
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/clients" className="text-light text-decoration-none">
                  <i className="fas fa-chevron-right me-2 small"></i>
                  Our Clients
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/industries" className="text-light text-decoration-none">
                  <i className="fas fa-chevron-right me-2 small"></i>
                  Our Industries
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/booking" className="text-light text-decoration-none">
                  <i className="fas fa-chevron-right me-2 small"></i>
                  Book a Service
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/contact" className="text-light text-decoration-none">
                  <i className="fas fa-chevron-right me-2 small"></i>
                  Contact Us
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/about" className="text-light text-decoration-none">
                  <i className="fas fa-chevron-right me-2 small"></i>
                  About Us
                </Link>
              </li>
            </ul>
          </Col>
        </Row>
        <hr className="my-4"/>
        <Row>
          <Col className="text-center">
            <p className="mb-0 small">
              &copy; 2025 Precision Analytical Lab Solutions East Africa Ltd. All rights reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;